module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 89
// module chunks = 0